import { datadogRum } from '@datadog/browser-rum'
// import { datadogLogs } from '@datadog/browser-logs'
// import { DD_CLIENT_TOKEN } from '../config/index'
// import { BACKEND_URL } from '~/config/index'
// import { VERSION } from '~/config/version'

export enum datadogAlertType {
  CRITICAL = 'CRITICAL',
}

let env = ''
if (typeof window !== 'undefined') {
  const w: any = window
  const href = w?.location?.href
  env =
    (href.includes('demo') && 'DEMO') ||
    (href.includes('staging') && 'STAGING') ||
    (href.includes('app') && 'PROD') ||
    (href.includes('isoprod') && 'ISOPROD') ||
    'LOCAL'
}

class LoggerHelper {
  constructor() {
    this.initDataDog()
  }

  private initDataDog = () => {
    // check if we are in the server or in the preview mode
    if (!window.location.href.includes('gojuno.io')) return
  }

  logError = async (message: string, context: any = {}) => {
    console.error(message, context)
    //datadogLogs?.logger.error(message, { context })
  }

  logEvent = async (event: string, params: any = {}) => {
    params.type = 'info'
    //datadogLogs?.logger.info(event)
  }

  logInfo = (msg: string) => {
    //datadogLogs?.logger.info(msg)
  }

  logWarning = (msg: string) => {
    //datadogLogs?.logger.warn(msg)
  }

  get datadogRum() {
    return datadogRum
  }
}

const loggerHelper = new LoggerHelper()

export default loggerHelper
